<template>
  <footer id="footer">
    <div id="customer">
      <h2 v-if="bd">ReRe/高く売れるドットコム
        <br class="sp_only">{{bd.label}}リユースセンター
      </h2>
    </div>
    <!--/customer-->
    <div id="copyright">
      <a href="https://www.marketenterprise.co.jp/" target="_blank">
        <img src="@/assets/common_me_logo.svg" alt="MarketEnterprise" class="footer_logo">
      </a>
      <p>
        {{corp_name}}
      </p>
      <ul>
        <li v-for="n in kouan_numbers" :key="n">{{n}}</li>
      </ul>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex"
import settings from "../settings"
export default {
  data() {
    return {
      corp_name: settings.companyData[0].corp_name,
      corp_name_en: settings.companyData[0].corp_name_en,
      haddress_zip: settings.companyData[0].head_office_zip,
      haddress_pref: settings.companyData[0].head_office_pref,
      haddress_address: settings.companyData[0].head_office_address,
      haddress_building: settings.companyData[0].head_office_building,
      kouan_numbers: settings.companyData[0].kouan_numbers,
      copyright: settings.companyData[0].copyright
    };
  },
  name: "footer-bar",
  computed: {
    ...mapGetters([
      "current_offer"
    ]),
    bd () {
      const _bd = this.current_offer.business_domain
      const _sbd = settings.businessDomains
      let bd = _sbd.filter(bd => bd.value === _bd)
      return bd[0]
    }
  }
};
</script>


<style lang="scss" scoped>
#footer {
  background-color: #000;
  border: 1px solid #dadada;
  color: #fff;
  margin-top: auto;
  #customer {
    background-color: #000;
    border: none;
    color: #fff;
  }
}

.footer_logo {
  height: 25px;
  width: 90px;
}

#customer {
  background-color: #fff;
  border: 1px solid #927f5e;
  border-radius: 8px;
  color: #000;
  margin: 20px auto 0 auto;
  overflow: hidden;
  padding-bottom: 10px;
  text-align: left;
  width: 1120px;
  h2 {
    font-size: 18px;
    margin-bottom: 0;
    padding: 0 10px 0 20px;
  }
  p {
    line-height: 150%;
    margin: 0;
    padding: 10px 20px 0 20px;
  }
  b {
    font-size: 20px;
  }
}

#copyright {
  border: 0;
  padding: 20px;
  width: 1120px;
  img {
    background-color: #fff;
    margin: 0;
    padding: 10px;
  }
  p {
    margin: 0 15px;
    padding: 0;
  }
  ul {
    font-size: 12px;
    width: 750px;
    li {
      width: calc(100% / 3);
    }
  }
}
@media screen and (max-width: 1119px) {
  #customer {
    margin: 15px;
    width: auto;
  }

  #copyright {
    width: auto;
    padding-top: 0;
    ul {
      margin-top: 15px;
      width: 100%;
      li {
        width: calc(100% / 4);
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  #copyright {
    ul {
      width: 100%;
    }
    p {
      margin: 0 0 0 8px;
      padding: 0;
    }
  }

  .details {
    margin: 20px auto !important;
  }
}
@media screen and (min-width: 960px) and (max-width: 1023px) {
  #copyright ul {
    clear: both;
    padding: 10px 25px 0 25px;
    width: auto;
    li {
      font-size: 11px;
      width: calc(100% / 3);
    }
  }
}
@media screen and (min-width: 601px) and (max-width: 959px) {
  #honsatei {
    .sp_only {
      display: none;
    }
    .pc_only {
      display: block;
    }
  }
  #copyright ul {
    padding: 0;
    li {
      width: calc(100% / 2);
    }
  }
}
@media screen and (max-width: 600px) {
  #customer,
  .details {
    clear: both;
    margin: 10px 10px 10px 0;
    width: auto;
  }

  #copyright {
    ul {
      box-sizing: border-box;
      clear: both;
      margin-top: 15px;
      padding: 0;
      width: 100%;
      li {
        clear: both;
        list-style-type: none;
        width: 100%;
      }
    }
    img {
      margin-bottom: 15px;
      width: 24%;
    }
  }

  #customer {
    b {
      font-size: 18px;
    }
    h2 {
      font-size: 4.4vw;
    }
  }
  .sp_only {
    display: block;
  }
  .pc_only {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterBar.vue